import { useState } from 'react';

export default function useUIState() {
  // UI state
  const [showprogress, setShowProgress] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openMedalModal, setOpenmedalmodal] = useState(false);
  const [openLoginModal, setOpenLogInModal] = useState(false);
  const [openBrowserModal, setOpenBrowsermodal] = useState(false);
  const [openPrivacyModal, setOpenprivacymodal] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [message, setMessage] = useState({body:"",severity:''});
  const [showAddresses, setShowAddresses] = useState(false);
  const [addAddress, setAddaddress] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [privacyTerms, setPrivacyterms] = useState({ policy: false, terms: false });
  const [isUserSearching, setIsUserSearching] = useState(false);
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const [openBrowserUpdateModal, setOpenBrowserUpdatemodal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Additional UI state
  const [isCategoryGroupLoaded, setIsCategoryGroupLoaded] = useState(false);
  const [isCategoryLoaded, setIsCategoryLoaded] = useState(false);
  const [isProductsLoaded, setIsProductsLoaded] = useState(false);
  const [isRecentProductsLoaded, setIsRecentProductsLoaded] = useState(false);
  const [isCartsLoaded, setIsCartsLoaded] = useState(false);
  const [isOrdersLoaded, setIsOrdersLoaded] = useState(false);
  const [isSlidesLoaded, setIsSlidesLoaded] = useState(false);
  const [isLinksLoaded, setIsLinksLoaded] = useState(false);
  const [isUserCountryLoaded, setisUserCountryLoaded] = useState(false);
  const [istempTokenLoaded, setIstempTokenLoaded] = useState(false);
  const [isFavoritesLoaded, setIsFavoritesLoaded] = useState(false);
  const [isStoreBalanceLoaded, setIsStoreBalanceLoaded] = useState(false);
  const [isOrdersSorted, setisOrdersSorted] = useState(false);
  const [appcredits, setAppcredits] = useState(null);
  const [nextClaimAvailable, setNextClaimAvailable] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [order, setOrder] = useState(null);
  const [storeProducts, setStoreProducts] = useState([]);
  const [stores, setStores] = useState([]);
  const [store, setStore] = useState(null);
  const [sales, setSales] = useState(null);
  const [account, setAccount] = useState(null);
  const [balance, setBalance] = useState(null);
  const [notification, setNotification] = useState(null);
  // Add more as needed

  return {
    showprogress, setShowProgress,
    openModal, setOpenModal,
    openMedalModal, setOpenmedalmodal,
    openLoginModal,setOpenLogInModal,
    openBrowserModal, setOpenBrowsermodal,
    openPrivacyModal, setOpenprivacymodal,
    openSnackBar, setOpenSnackBar,
    message, setMessage,
    showAddresses, setShowAddresses,
    addAddress, setAddaddress,
    selectedOrder, setSelectedOrder,
    selectedGroup, setSelectedGroup,
    privacyTerms, setPrivacyterms,
    isUserSearching, setIsUserSearching,
    keyboardVisible, setKeyboardVisible,
    openBrowserUpdateModal, setOpenBrowserUpdatemodal,
    showModal, setShowModal,
    isOrdersSorted, setisOrdersSorted,
    appcredits, setAppcredits,
    nextClaimAvailable, setNextClaimAvailable,
    addresses, setAddresses,
    order, setOrder,
    storeProducts, setStoreProducts,
    stores, setStores,
    store,setStore,
    sales, setSales,
    account, setAccount,
    balance, setBalance,
    notification, setNotification,
// Additional UI state
    isCategoryGroupLoaded, setIsCategoryGroupLoaded,
    isCategoryLoaded, setIsCategoryLoaded,
    isProductsLoaded, setIsProductsLoaded,
    isRecentProductsLoaded, setIsRecentProductsLoaded,
    isCartsLoaded, setIsCartsLoaded,
    isOrdersLoaded, setIsOrdersLoaded,
    isSlidesLoaded, setIsSlidesLoaded,
    isLinksLoaded, setIsLinksLoaded,
    isUserCountryLoaded, setisUserCountryLoaded,
    istempTokenLoaded, setIstempTokenLoaded,
    isFavoritesLoaded, setIsFavoritesLoaded,
    isStoreBalanceLoaded, setIsStoreBalanceLoaded,    
  };
}
